import React, { FC } from "react";
import { OptionMenuClassName } from "./OptionMenu";

const OptionMenuSeparator: FC = () => {
  return <hr className={`${OptionMenuClassName}__separator`} />;
};

export default OptionMenuSeparator;
